/* @flow */

import * as React from 'react';
import {CloudUploadIcon} from '../../icon';

import './file-upload-button.css';

type Props = {
    id: string,
    name: string,
    onChange?: (file: any) => void,
    // This is passed for custom on-click behavior (override browser default)
    onClick?: () => void,
    accept?: string,
};

export function FileUploadButton(props: Props) {
    function handleUpload(event: SyntheticInputEvent<*>) {
        if (props.onChange) {
            props.onChange(event.target.files[0]);
        }
    }
    function handleClick(event: SyntheticInputEvent<*>) {
        event.preventDefault();
        if (props.onClick) {
            props.onClick();
        }
    }

    return (
        <label htmlFor={props.id} styleName='file-upload-wrapper'>
            <input
                accept={props.accept}
                type='file'
                id={props.id}
                name={props.name}
                onChange={handleUpload}
                onClick={props.onClick ? handleClick : undefined}
            />
            <div styleName='contents'>
                <CloudUploadIcon size={48} /> <span>Click here to upload a file</span>
            </div>
        </label>
    );
}
